import { getTimezonesForCountry, getAllCountries } from "countries-and-timezones";

// Default avatar URL
export const DEFAULT_AVATAR = "https://i.pravatar.cc/80?img=47";

// IgniteNext admin address silently BCC'd on outbound mentor emails (clarity requests, etc.)
export const IGNITENEXT_ADMIN_EMAIL = "admin@ignitenext.org";

/**
 * Get timezone options for a country (ISO 2-letter code).
 * Returns array of strings: "Timezone/Name (UTC±HH:MM)" for use in dropdowns.
 */
export function getTimezoneOptionsForCountry(countryCode) {
  if (!countryCode || typeof countryCode !== "string") return [];
  const list = getTimezonesForCountry(countryCode.trim().toUpperCase());
  if (!list || !Array.isArray(list)) return [];
  return list
    .filter((tz) => tz && !tz.deprecated)
    .map((tz) => `${tz.name} (UTC${tz.utcOffsetStr})`);
}

// Common country name aliases (e.g. from react-country-state-city) -> ISO2
const COUNTRY_NAME_TO_CODE = {
  "United States": "US",
  "United Kingdom": "GB",
  "United States of America": "US",
};

/**
 * Get country ISO 2-letter code from country name (e.g. "United States" -> "US").
 */
export function getCountryCodeFromName(countryName) {
  if (!countryName || typeof countryName !== "string") return null;
  const name = countryName.trim();
  if (COUNTRY_NAME_TO_CODE[name]) return COUNTRY_NAME_TO_CODE[name];
  const all = getAllCountries();
  const found = Object.values(all || {}).find(
    (c) => c && c.name && (c.name === name || c.name.toLowerCase() === name.toLowerCase())
  );
  return found ? found.id : null;
}
